export default {
  nav: {
    login: 'Log In',
  },
  hero: {
    badge: 'In-hotel medical service at your door',
    h1: 'A professional doctor, right to the door of your room',
    sub: 'Care available {h}, fast and safe. No queues, no travel — the help you need comes to you.',
    cta_primary: 'Book an appointment',
    cta_secondary: 'View my file',
    pill1: 'Certified doctors',
    pill2: 'Available 24/7',
    pill3: 'Digital medical record',
  },
"steps": {
  "tag": "How it works?",
  "h2": "Medical care in four simple steps",
  "items": [
    {
      "title": "Request care",
      "desc": "Inform the reception staff, concierge or your host that you need medical attention."
    },
    {
      "title": "We receive your request",
      "desc": "We take care of coordinating everything to provide you with the care you need."
    },
    {
      "title": "The doctor comes to you",
      "desc": "We assign the nearest doctor and they come directly to your room door."
    },
    {
      "title": "Check your medical record",
      "desc": "Receive the care you need and consult your digital medical record from this page."
    }
  ]
},
  search: {
    tag: 'Digital medical record',
    h2: 'View and download your medical record',
    sub: 'Enter your case number or code to view and download your digital file.',
    placeholder: 'E.g. DOM-2026-00184',
    btn: 'Search',
    searching: 'Searching…',
  },
  faq: {
    tag: 'Frequently asked questions',
    h2: 'We answer your questions',
    items: [
      {
        q: 'How long does it take for the doctor to arrive?',
        a: 'In covered areas, the doctor reaches your room within an average of 30 to 60 minutes after confirming your appointment. We keep you informed of the estimated time at all times.',
      },
      {
        q: 'What types of medications can be prescribed?',
        a: 'Our certified physicians can issue prescriptions for most common-use medications. Controlled substances are handled in accordance with current health regulations.',
      },
      {
        "q": "Who can view my medical record?",
        "a": "Only the person who has the folio assigned during the consultation can access the digital medical record. All medical and personal information is protected in accordance with Mexican legislation on personal data protection."
      },
    ],
  },
  footer: {
    tagline: 'In-hotel medical service for hotel guests. Professional, fast, and reliable care, 24 hours a day.',
    contact: 'Contact',
    available: 'Care 24/7',
    account: 'Account',
    login: 'Log In',
    receipt: 'View medical record',
    survey: 'Satisfaction Survey',
    rights: '© 2026 Domédica. All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms and Conditions',
  },
  print: {
    title: 'MEDICAL CONSULTATION',
    date: 'Date',
    folio: 'Folio',
    patient: 'PATIENT INFORMATION',
    full_name: 'Full name',
    age: 'Age',
    years: 'years',
    gender: 'Gender',
    phone: 'Phone',
    country: 'Country',
    language: 'Language',
    hotel: 'Hotel / Partner',
    patient_type: 'Patient type',
    guest: 'Guest',
    collaborator: 'Collaborator',
    vitals: 'VITAL SIGNS',
    bp: 'Blood pressure',
    temp: 'Temperature',
    hr: 'Heart rate',
    spo2: 'O₂ Saturation',
    respiratory_rate: 'Respiratory rate',
    anthropometrics: 'ANTHROPOMETRIC DATA',
    weight: 'Weight',
    height: 'Height',
    bmi: 'BMI',
    nutrition_goal: 'Nutrition goal',
    additional_services: 'ADDITIONAL SERVICES',
    psych_eval: 'PSYCHOLOGICAL EVALUATION',
    consult_reason: 'Reason for consultation',
    mood: 'Mood',
    risk_level: 'Risk level',
    history: 'MEDICAL HISTORY',
    diseases: 'Previous illnesses',
    allergies: 'Allergies',
    medication: 'Current medication',
    diagnosis: 'DIAGNOSIS AND PLAN',
    symptoms: 'Symptoms',
    diagnosis_label: 'Diagnosis',
    observations: 'OBSERVATIONS AND RECOMMENDATIONS',
    not_registered: 'NOT REGISTERED',
    translating: 'Translating…',
    download: 'Download PDF',
    send: 'Send by Email',
    back: 'Back to registry',
    doctor: 'Doctor',
    license: 'Medical license',
    signature: 'Signature',
  },
  survey: {
    title: 'Satisfaction Survey',
    subtitle: 'Your feedback helps us improve our service. All questions marked with * are required.',
    hotel_label: 'Which hotel were you staying at?',
    hotel_placeholder: 'Select your hotel',
    hotel_other: 'Other',
    hotel_other_placeholder: 'Enter the hotel name',
    hint_poor_excellent: '1 = Poor, 5 = Excellent',
    hint_not_clear: '1 = Not clear at all, 5 = Very clear',
    hint_not_likely: '1 = Not at all likely, 5 = Very likely',
    q_tiempo_espera: 'How would you rate the waiting time from your service request to the doctor’s arrival?',
    q_gafete: 'Did the doctor properly wear their ID badge during the visit?',
    q_presentacion: 'How would you rate the doctor’s professional presentation and image (uniform, hygiene and overall appearance)?',
    q_atencion_medico: 'How would you rate the care provided by the doctor?',
    q_claridad_explicacion: 'How clear was the doctor’s explanation of your diagnosis, treatment and follow-up care?',
    q_ingles: 'How would you rate the doctor’s level of English during the consultation?',
    q_calidad_precio: 'How would you rate the value for money of the medical service received?',
    q_atencion_domedica: 'How would you rate the overall service provided by Domédica?',
    q_recomendacion: 'How likely are you to recommend Domédica to family or friends visiting Oaxaca?',
    comments_label: 'Any additional comments?',
    comments_placeholder: 'Tell us more…',
    submit: 'Submit survey',
    sending: 'Sending…',
    incomplete_title: 'Incomplete form',
    incomplete_text: 'Please complete all required questions.',
    error_title: 'Error',
    error_default: 'The survey could not be submitted.',
    thanks_title: 'Thank you for your response!',
    thanks_text: 'Your feedback was recorded successfully.',
    back: 'Back to home',
    scan_qr: 'Scan to take the survey',
  },
  services: {
    tag: 'Additional services',
    h2: 'Additional service costs',
    sub: 'These charges may apply in addition to the consultation cost, depending on the medical care you require.',
    concept: 'Concept',
    base_price: 'Base price',
    items: [
      { concept: 'Attending a second, non-scheduled patient', price: '75% of the first consultation cost' },
      { concept: 'Issuance of additional or special-requirement prescriptions', price: '$100.00' },
      { concept: 'Simple wound care', price: '$250.00' },
      { concept: 'Stitch removal', price: '$250.00' },
      { concept: 'Injectable medication administration (medication not included)', price: '$120.00' },
      { concept: 'Simple suture (up to 3 cm)', price: '$600.00' },
      { concept: 'Intermediate suture (3-5 cm)', price: '$800.00' },
      { concept: 'Major suture (more than 5 cm)', price: '$1,000.00' },
    ],
  },
};
